import React, { useState } from "react";
import * as UTILS from "../../helpers/Utility";
import { Grid } from "@mui/material";

export default function DateField(props) {
  var years = [((new Date()).getFullYear() + 1).toString()];
  for(var i = 0; i < 10; i++) {
    years.push(((new Date()).getFullYear() - i).toString());
  };

  let today = new Date();
  const [month, setMonth] = useState(props.month);
  const [day, setDay] = useState(props.day);
  const [year, setYear] = useState(props.year || today.getFullYear());
  const [calcDaysInMonth, setCalcDaysInMonth] = useState(UTILS.daysInMonth(today.getFullYear(), today.getMonth()));
  let arrayFromKeys = calcDaysInMonth ? Array.from(Array(calcDaysInMonth).keys()) : null;
  let days = arrayFromKeys ? arrayFromKeys.map((el) => el + 1).slice(0,arrayFromKeys.length-1) : [];

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={4}>
          <select
            name={'month'}
            value={month}
            onChange={(d) => {
              if (d.target.value) {
                let daysInMonth = UTILS.daysInMonth((new Date()).getFullYear(), d.target.value);

                setMonth(d.target.value);
                setCalcDaysInMonth(daysInMonth);

                if (year && day) {
                  let date = UTILS.getDate(d.target.value, day, year);

                  if (props.onChange) {
                    props.onChange(date);
                  }
                  if (props.setFieldValue) {
                    props.setFieldValue("date", date);
                    props.setFieldValue("dateField", date.toString());
                  }
                } else {
                  if (props.onChange) {
                    props.onChange(null);
                  }
                  if (props.setFieldValue) {
                    props.setFieldValue("date", null);
                    props.setFieldValue("dateField", null);
                  }
                }
              }
            }}
          >
            <option>Month</option>
            <option value='1'>January</option>
            <option value='2'>February</option>
            <option value='3'>March</option>
            <option value='4'>April</option>
            <option value='5'>May</option>
            <option value='6'>June</option>
            <option value='7'>July</option>
            <option value='8'>August</option>
            <option value='9'>September</option>
            <option value='10'>October</option>
            <option value='11'>November</option>
            <option value='12'>December</option>
          </select>
        </Grid>
        <Grid item xs={12} sm={4}>
          <select
            name={'day'}
            value={day}
            onChange={(d) => {
              if (d.target.value) {
                setDay(d.target.value);
                if (year && month) {
                  let date = UTILS.getDate(month, d.target.value, year);
                  if (props.onChange) {
                    props.onChange(date);
                  }
                  if (props.setFieldValue) {
                    props.setFieldValue("date", date);
                    props.setFieldValue("dateField", date.toString());
                  }
                } else {
                  if (props.onChange) {
                    props.onChange(null);
                  }
                  if (props.setFieldValue) {
                    props.setFieldValue("date", null);
                    props.setFieldValue("dateField", null);
                  }
                }
              } else {
                if (props.onChange) {
                  props.onChange(null);
                }
                if (props.setFieldValue) {
                  props.setFieldValue("date", null);
                  props.setFieldValue("dateField", null);
                }
              }
            }}
          >
          <option>Day</option>
            { days.map((i) => {
                return(
                  <option key={i} value={i}>{i}</option>
                )
              })
            }
          </select>
        </Grid>
        <Grid item xs={12} sm={4}>
          <select
            name={'year'}
            value={year}
            onChange={(d) => {
              if (d.target.value) {
                setYear(d.target.value);
                if (day && month) {
                  let date = UTILS.getDate(month, day, d.target.value);
                  if (props.onChange) {
                    props.onChange(date);
                  }
                  if (props.setFieldValue) {
                    props.setFieldValue("date", date);
                    props.setFieldValue("dateField", date.toString());
                  }
                }
              } else {
                if (props.onChange) {
                  props.onChange(null);
                }
                if (props.setFieldValue) {
                  props.setFieldValue("date", null);
                  props.setFieldValue("dateField", null);
                }
              }
            }}
          >
          <option>Year</option>
          { years.map((i) => {
              return(
                <option key={i} value={i}>{i}</option>
              )
            })
          }
          </select>
        </Grid>
      </Grid>
      {(props.values && props.touched) && !props.values.date && props.touched.date && (
        <div className="error">
          <MdError /> {props.errors.date}
        </div>
      )}
    </>
  );
}
